/**Componentes React */
import { useEffect, useState } from 'react';

/**Librerías de terceros */

/**Archivos de configuración */
import { store } from '@/data/libraries/Store';

/** Controladores */
import BranchOfficesController from '@/controllers/BranchOfficesController';

/**Interfaces  declaradas como tipos */
import { type IBranchOffice } from '@/domain/interfaces/IBranchOffice';

/**Redux & CustomHooks */
import { useAppSelector } from '@/ui/store/helperRedux';
import { RootState } from '@/ui/store/store';
import { ScreenSize, useScreenSize } from '@/ui/hooks/useScreenSize';

/**Utilidades */
import { translate } from '@/domain/utils/translate';

/**Assets */
/**Componentes */
import ContactItem from '@/ui/components/store/ContactItem'
import { Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import StoreJSONController from '@/controllers/StoreJSONController';
import { IStoreJsonConfiguration } from '@/domain/interfaces/IStoreJsonConfiguration';
import { ISocialMedia } from '@/domain/interfaces/ISocial';
import Icon from '@/ui/assets/Icon';

interface ContactInformationProps {
    /** Activar colores primarios */
    customColor?: string;
}


const ContactInformation = ({ customColor = '' }: ContactInformationProps) => {



    /** Hook que contiene las dimensiones de la pantalla y maneja los componentes de acuerdo al resultado obtenido */
    const { width, maxLargeWidth }: ScreenSize = useScreenSize();

    /** Variable que define si es entorno mobile o desktop */
    const isMobile: boolean = width < maxLargeWidth;

    /** Controlador de sucursales */
    const { getBranchOffices } = BranchOfficesController();

    /** Valor del ID de la tienda */
    const storeId: number = store.DEFAULT;

    /** State Redux de Tienda */
    const storeData = useAppSelector((state: RootState) => state.storeData);

    /** Estado para almacenar las sucursales */
    const [branchOffices, setBranchOffices] = useState<IBranchOffice[]>([]);

    // Buscar específicamente el elemento de WhatsApp
    const getWhatsAppMedia = () => {
        if (socialMedia?.info) {
            return socialMedia.info.find(media =>
                media.name?.toLowerCase() === 'whatsapp'
            );
        }
        return null;
    };


    const { getStoreJsonConfiguration } = StoreJSONController();

    /** estado de redes sociales*/
    const [socialMedia, setSocialMedia] = useState<ISocialMedia | null>(null);
    //trae la configuracion del json
    const getStoreConfiguration = async () => {
        try {
            const data: IStoreJsonConfiguration | null = await getStoreJsonConfiguration();
            if (data) {
                setSocialMedia(data.socialMedia || null);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const whatsAppMedia = getWhatsAppMedia();

    ///useEffect que trae las secciones y redes sociales y carruseles de imágenes a traves del controlador
    useEffect(() => {
        getStoreConfiguration();
    }, []);


    /** Carga las sucursales al montar el componente */
    useEffect(() => {
        const loadBranchOffices = async () => {
            const offices = await getBranchOffices(storeId);
            setBranchOffices(offices);
        };
        loadBranchOffices();
    }, [storeId]);


    // Generar un ID único
    const generateNumberId = () => {
        return Math.floor(Math.random() * 1000000);
    };

    // Estado para manejar el hover
    const [isHovered, setIsHovered] = useState(false);
    const CONTACT_US_WHATSAPP_TITLE: string = translate('modals.contact_us_modal_whatsapp_title');

    const CONTACT_US_EMAIL_TITLE: string = translate('modals.contact_us_modal_email_title');

    const CONTACT_US_PHONE_TITLE: string = translate('modals.contact_us_modal_phone_title');

    const CONTACT_US_ADDRESS_TITLE: string = translate('modals.contact_us_modal_address_title');

    const CONTACT_US_HOURS_TITLE: string = translate('modals.contact_us_modal_hours_title');

    return (
        <>
            <Col className='d-flex flex-column pt-2 '>
                {whatsAppMedia && (
                    <NavLink
                        key={generateNumberId()}
                        to={whatsAppMedia.url}
                        target='_blank'
                        rel='noreferrer'
                        className="text-decoration-none"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <Col className='border-2 rounded hover-border'>
                            <ContactItem
                                iconName='ico-whatsapp'
                                title={CONTACT_US_WHATSAPP_TITLE}
                                iconClass={`pe-3 svg-${customColor}`}
                                childrenClass='ps-3'
                                customTitle={
                                    <Col className='d-flex justify-content-between align-items-center pb-1 w-100'>
                                        <span className={`paragraph fw-bold text-${customColor} ${isMobile ? 'ps-2' : ''}`}>{CONTACT_US_WHATSAPP_TITLE}</span>
                                        <Icon
                                            name='ico-right-arrow-small'
                                            classMain={`pe-2 ${isHovered ? 'svg-primary-1' : 'svg-secondary-1'}`}
                                            size={14}
                                        />
                                    </Col>
                                }
                                content={`+56 ${storeData.notificationsPhone.number}`}
                            />
                        </Col>
                    </NavLink>
                )}
            </Col>


            <ContactItem
                iconName='ico-email'
                iconClass={`pe-3 svg-${customColor}`}
                childrenClass='ps-3'
                title={CONTACT_US_EMAIL_TITLE}
                titleClass={`text-${customColor}`}
                content={storeData.notificationsEmail}
            />

            <ContactItem
                iconName='ico-phone-call'
                iconClass={`pe-3 svg-${customColor}`}
                childrenClass='ps-3'
                title={CONTACT_US_PHONE_TITLE}
                titleClass={`text-${customColor}`}
                content={`+56 ${storeData.notificationsPhone.number}`}
                size={28}
            />

            <ContactItem
                iconName='ico-address'
                iconClass={`pe-3 svg-${customColor}`}
                childrenClass='ps-3'
                title={CONTACT_US_ADDRESS_TITLE}
                titleClass={`text-${customColor}`}
                content={branchOffices.length > 0 ? branchOffices[0].contact.address : 'No hay dirección disponible'}
            />

            <ContactItem
                iconName='ico-clock'
                iconClass={`pe-3 svg-${customColor}`}
                childrenClass='ps-3'
                title={CONTACT_US_HOURS_TITLE}
                titleClass={`text-${customColor}`}
                size={28}
            >
                <ul className={`${isMobile ? 'd-flex flex-column align-items-start justify-content-start' : ' ps-3'}`}>
                    {branchOffices.length > 0 && branchOffices[0].schedule.weekdaysSchedule && (
                        <li><span className='text-secondary-2'>{branchOffices[0].schedule.weekdaysSchedule}</span></li>
                    )}
                    {branchOffices.length > 0 && branchOffices[0].schedule.saturdaySchedule && (
                        <li><span className='text-secondary-2'>{branchOffices[0].schedule.saturdaySchedule}</span></li>
                    )}
                    {branchOffices.length > 0 && branchOffices[0].schedule.sundaySchedule && (
                        <li><span className='text-secondary-2'>{branchOffices[0].schedule.sundaySchedule}</span></li>
                    )}
                </ul>
            </ContactItem>
        </>
    )
}

export default ContactInformation